import { render, staticRenderFns } from "./AnswerTypeStarRating.vue?vue&type=template&id=43351b30"
import script from "./AnswerTypeStarRating.vue?vue&type=script&lang=js"
export * from "./AnswerTypeStarRating.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports